/* ============================================================================
 * konektra Flex Checkout – Bridge-JS
 * ----------------------------------------------------------------------------
 * Läuft auf der Shop-Seite, die den Combeenation-Konfigurator per iframe
 * einbettet. Übernimmt das "Add to Cart", das früher das Combeenation-Plugin
 * gemacht hätte.
 *
 * Ablauf:
 *   1. Konfigurator ruft beim Kauf-Klick window.Combeenation.onCheckout(data)
 *   2. Wir parsen data.checkoutParameters → configuration (price, title, bom …)
 *   3. Für jede bom-Komponente lösen wir SKU → Shopify variantGid auf
 *      (Storefront API, clientseitig, öffentlicher Token). Entscheidung E3.
 *   4. Wir legen EINE Parent-Position per /cart/add.js in den Warenkorb –
 *      mit _Stückliste-Property (variantGid + quantity als JSON) sowie
 *      Anzeige-Properties für Titel/Bild/Details.
 *   5. Die Cart Transform Function löst _Stückliste serverseitig via
 *      lineExpand in die Einzelkomponenten auf, bevor die Bestellung entsteht.
 *
 * WICHTIG: Diese Datei enthält KEINE Admin-Credentials. Der Storefront-Token
 * ist ein öffentlicher Token (X-Shopify-Storefront-Access-Token) und für den
 * Client-Einsatz gedacht.
 * ==========================================================================*/

(function () {
  "use strict";

  // ==========================================================================
  // 1) KONFIGURATION  — vor Go-Live anpassen
  // ==========================================================================
  // ┌──────────────────────────────────────────────────────────────────────────┐
  // │ STORE-SPEZIFISCHE WERTE — beim Upload in den jeweiligen Store anpassen!  │
  // │ Diese Datei ist als Theme-Asset je Store hinterlegt, es gibt also KEINE  │
  // │ automatische Erkennung. Drei Zeilen unterscheiden sich:                   │
  // │                                                                          │
  // │ konektra DE                                                              │
  // │   STOREFRONT_DOMAIN  konektrashop.myshopify.com                          │
  // │   ⚠️ NICHT konektra.myshopify.com — anderer, gesperrter Store, jeder      │
  // │      Storefront-Call dorthin gibt 401 (04.08.2026 live geprüft).         │
  // │   STOREFRONT_TOKEN   28b2678e4deabe7da0f2749a336cb3f5                    │
  // │   PARENT_VARIANT_ID  62860361466186                                      │
  // │                                                                          │
  // │ konektra CH                                                              │
  // │   STOREFRONT_DOMAIN  konektra-ch.myshopify.com                           │
  // │   STOREFRONT_TOKEN   ab761bace4e810e778b4e02b3fdd643f                    │
  // │   PARENT_VARIANT_ID  49875051610354                                      │
  // │                                                                          │
  // │ Testumgebung                                                             │
  // │   STOREFRONT_DOMAIN  konektra-testumgebung.myshopify.com                 │
  // │   STOREFRONT_TOKEN   6563c51506f236c83edb25fe30022efa                    │
  // │   PARENT_VARIANT_ID  48267244175545                                      │
  // │                                                                          │
  // │ Stand 04.08.2026: Die Prod-Bundle-Produkte wurden neu angelegt (nach dem  │
  // │ Deinstallieren war die Bundle-Ownership der alten Produkte gesperrt), die  │
  // │ IDs oben sind die NEUEN.                                                  │
  // │                                                                          │
  // │ ⚠️ Falsche Kombination = Storefront-Suche findet keine Komponenten oder   │
  // │ es landet die Parent-Variante eines anderen Stores im Warenkorb.         │
  // └──────────────────────────────────────────────────────────────────────────┘
  const CONFIG = {
    // Shop-Domain (myshopify oder Custom-Domain, beides geht für Storefront API)
    STOREFRONT_DOMAIN: "konektrashop.myshopify.com",

    // Öffentlicher Storefront-API-Token (KEIN Admin-Token!).
    // Prod: über den Headless-Kanal angelegt (Public access token),
    // Scope unauthenticated_read_product_listings.
    STOREFRONT_TOKEN: "28b2678e4deabe7da0f2749a336cb3f5",

    // Storefront-API-Version. KEINE Einstellung des Tokens, sondern Teil der
    // Endpoint-URL — deshalb steht sie nirgends im Headless-Kanal. Quartalsweise
    // aktualisieren, der öffentliche Token gilt für jede unterstützte Version.
    STOREFRONT_API_VERSION: "2026-07",

    // Numerische Varianten-ID des Konfigurator-Parent-Produkts, das in den
    // Cart gelegt wird. Kommt aus dem Banner des Buttons „Bundle-Setup
    // aktivieren" — je Store eine ANDERE ID (s. Kasten oben).
    PARENT_VARIANT_ID: 62860361466186, // konektra DE (Tag konektra_bundle_parent)

    // Trennung je Konfigurator: seit Weg B übernimmt das die Cart Transform
    // Function — sie fügt je Konfiguration eine 0-€-Kopfzeile als ERSTE Position
    // der Gruppe ein (steht damit garantiert direkt vor ihren Komponenten). Die
    // Bridge legt KEINE eigene Trenner-Zeile mehr an (eine eigenständige Zeile
    // klumpte in der Bestellung zusammen und verwirrte im Warenkorb).
    // Deshalb hier auf false. Die Kopfzeilen-Variante kennt die Function aus
    // einem Cart-Transform-Metafield (vom Setup-Button gesetzt) — nicht von hier.
    ADD_SEPARATOR: false,
    // (Obsolet bei Weg B — nur relevant, falls ADD_SEPARATOR wieder aktiviert wird.
    // Der Wert stammt von der TESTUMGEBUNG und gilt auf Prod NICHT. Wer ADD_SEPARATOR
    // je wieder einschaltet, muss die Trenner-Variante des jeweiligen Stores eintragen.)
    SEPARATOR_VARIANT_ID: 48361957032121,

    // Konfigurator-Preis erzwingen (E1): verteilt configuration.price auf die
    // Komponenten (fixedPricePerUnit). Falls der Add damit 422 wirft,
    // auf false stellen → echte Shop-Variantenpreise (Fallback).
    ENFORCE_CONFIGURATOR_PRICE: true,

    // Konfigurator-Rendering als Bundle-Bild mitschicken (_bundleImage).
    // Die Function setzt daraus den Bild-Override der Bundle-Position
    // (LineExpandOperation.image.url) — der EINZIGE Weg, das Bild in den
    // Checkout zu bekommen. Der Warenkorb braucht das nicht: dort läuft es
    // über _configImage + Theme-Snippet, ohne Function und ohne 422-Risiko.
    //
    // ⚠️ MUSS false BLEIBEN. Am 05.08.2026 auf Prod (Plus, DE) mit true
    // getestet: Add → 422 „Warenkorb-Fehler". Shopify lehnt den Override ab,
    // die Function wirft InvalidOutputErr, blockOnFailure blockiert den Add.
    //
    // An der URL liegt es NICHT — dieselbe geprüft: HTTP 200 ohne Login,
    // Content-Type image/png, 90 KB, 1395×800, 103 Zeichen, kein Query-String,
    // CORS offen. Trotz „publicly accessible URL" im Schema akzeptiert Shopify
    // hier offenbar nur Bilder von der eigenen CDN. Damit ist das Bild im
    // Checkout ohne Upload nach Shopify Files nicht zu haben (s. Paket A).
    //
    // Der Warenkorb braucht das hier ohnehin nicht: dort läuft das Bild über
    // _configImage + Theme-Snippet, ohne Function und ohne 422-Risiko.
    SEND_BUNDLE_IMAGE: false,

    // Nach erfolgreichem Add-to-Cart hierhin weiterleiten.
    // ⚠️ Ohne Sprachpräfix angeben. Die Bridge setzt es selbst davor
    // (window.Shopify.routes.root) → "/cart" bzw. "/en/cart". Sonst landet
    // jeder Kunde im Warenkorb der Standardsprache.
    CART_REDIRECT_URL: "/cart",

    // Bundle-Titel je Sprache selbst setzen. Combeenation liefert den Titel
    // (checkoutParameters.title) immer auf Deutsch — als einziger Text im
    // Warenkorb/Checkout bleibt er sonst unübersetzt. Da der Titel konstant ist,
    // setzen wir ihn hier fest je Locale (Sprachteil aus window.Shopify.locale,
    // z. B. "de-CH" → "DE"). Passt kein Eintrag, gilt Combeenations Originaltitel.
    // ⚠️ Enthält bewusst den Modellnamen. Kommt je ein NEUES Modell dazu, hier
    // ergänzen (oder Combeenation liefert den Titel lokalisiert — dann diesen
    // Block leeren).
    BUNDLE_TITLE_BY_LOCALE: {
      DE: "Dein individuelles SYSTEM 01",
      EN: "Your custom SYSTEM 01",
      FR: "Votre SYSTEM 01 personnalisé",
      IT: "Il tuo SYSTEM 01 personalizzato",
      ES: "Tu SYSTEM 01 personalizado",
    },

    // Hinweis: Die Konfig-ID wird bewusst NICHT auf Auftragsebene geschrieben.
    // Order-Attribute (note_attributes) kamen in plentymarkets nicht an, und die
    // Bestellnotiz (order.note) soll dem Kunden vorbehalten bleiben (Wunsch des
    // Händlers, 15.09.2026). Die ID steht weiterhin als Positions-Property in der
    // Shopify-Bestellung (Function-Attribut auf der Kopfzeile); ein plenty-tauglicher
    // Weg ist offen und müsste connector-/plugin-seitig gelöst werden.

    // Basis-URL des eingebetteten Konfigurators (ohne abschließenden Slash).
    // Für den Rücksprung aus dem Warenkorb: die Edit-URL wird als
    // `${CONFIGURATOR_BASE_URL}/${id}/edit/${authentication}` gebaut (id +
    // authentication liefert Combeenation beim Checkout, s. onCheckout-Rohdaten).
    // ⚠️ Muss der im Theme eingebetteten Konfigurator-Instanz entsprechen
    // (Demo/Staging vs. Live) und ggf. je Store unterschiedlich sein (DE/CH).
    //
    // ⚠️⚠️ MUSS IMMER MIT DEM `data-cfgrurl` DES IFRAMES ÜBEREINSTIMMEN.
    // Combeenation (Thomas, 04.08.2026) geht in zwei Stufen live:
    //   Stufe 1 — Go-Live mit der Demo-Instanz (dieser Wert, s. unten)
    //   Stufe 2 — Combeenation deployt auf Live, DANN im iframe UND hier
    //             umstellen auf: https://portal.combeenation.com/cfgr/SWISSMOBILIA/MOEBELSYSTEM
    // Beide Stellen gemeinsam ändern! Wird nur das iframe umgestellt, erzeugt die
    // Bridge Rücksprung-Links in die alte Instanz, in der die neuen Konfigurations-
    // IDs nicht existieren. Bereits im Warenkorb liegende Positionen behalten ihre
    // damals gebaute URL (sie steckt als Property in der Zeile) und brechen nicht.
    // LEER = fail-safe: dann baut die Bridge gar keinen Rücksprung-Link.
    CONFIGURATOR_BASE_URL:
      "https://portal.combeenation.com/cfgr/SWISSMOBILIA/MOEBELSYSTEM",

    // Shop-Seite, die den Konfigurator per iframe einbettet. Für den Rücksprung
    // MUSS die Combeenation-Edit-URL URL-encodiert als ?combeenationurl=… an
    // diese Seite gehängt werden, damit der Konfigurator INNERHALB des Shops
    // öffnet — nur so lässt sich die bearbeitete Konfiguration wieder in den
    // Warenkorb legen (Combeenation-Vorgabe). Relativer Pfad reicht (gleiche Domain).
    // Auf Prod ist das eine COLLECTION-Seite, keine Page — das iframe wird dort
    // eingebunden. Der `combeenationurl`-Parameter funktioniert auf jeder Seite,
    // das Plugin liest ihn aus location.href.
    // ⚠️ Je Store prüfen: DE und CH können abweichende Handles haben.
    // ⚠️ Ohne Sprachpräfix angeben — die Bridge setzt es selbst davor.
    CONFIGURATOR_PAGE_URL: "/collections/configurator",

    // bom-Feldnamen aus dem Combeenation-JSON
    BOM_SKU_FIELD: "id", // Combeenation liefert die Shop-SKU im Feld "id"
    BOM_QTY_FIELD: "quantity",

    // E4: HMAC-Absicherung. Combeenation liefert checkoutParameters (JSON-
    // ROH-String) + checkoutParametersHash (HMAC-SHA-256, Base64). Beides wird
    // UNVERÄNDERT als _checkoutParameters/_checkoutParametersHash durchgereicht;
    // die Cart Transform Function verifiziert serverseitig und expandiert ohne
    // gültige Signatur NICHT (Position bleibt unkaufbar — fail-closed).
    // true = Add-to-Cart bricht ohne Signatur sofort mit Fehlermeldung ab.
    // Nur zum Debuggen auf false stellen (die Function blockt trotzdem hart).
    REQUIRE_HMAC: true,

    // Debug-Logs in der Konsole (vor Go-Live auf false)
    DEBUG: true,
  };

  // ==========================================================================
  // 2) Kleine Helfer
  // ==========================================================================
  const log = (...a) => CONFIG.DEBUG && console.warn("[konektra-bridge]", ...a);
  const err = (...a) => console.error("[konektra-bridge]", ...a);

  // Garantiert eindeutiger Schlüssel je Konfigurator-Instanz. Wird auf die
  // Parent-Position gelegt, damit zwei Adds NIE zu einer Cart-Line verschmelzen —
  // unabhängig davon, ob Combeenation eine configurationId liefert oder zwei
  // Konfigurationen identisch sind. (Shopifys Ajax-Cart fasst Zeilen nur bei
  // exakt gleicher Variante UND gleichen Properties zusammen.)
  function uniqueInstanceKey() {
    try {
      if (window.crypto && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
      }
    } catch (_) {}
    return Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
  }

  // Zählt die bereits im Warenkorb liegenden Trenner-Zeilen (per Varianten-ID),
  // um dem nächsten Trenner eine laufende Nummer zu geben ("Konfiguration 1/2…").
  // Rein kosmetisch → bei jedem Fehler einfach 0 (keine Nummer).
  async function countExistingSeparators() {
    try {
      const res = await fetch(localizedPath("/cart.js"), {
        headers: { Accept: "application/json" },
      });
      if (!res.ok) return 0;
      const cart = await res.json();
      const items = Array.isArray(cart.items) ? cart.items : [];
      return items.filter(
        (it) => Number(it.variant_id) === Number(CONFIG.SEPARATOR_VARIANT_ID)
      ).length;
    } catch (_) {
      return 0;
    }
  }

  // Sprachpräfix des Shops. Auf mehrsprachigen Shops liegt jede Seite unter
  // einem Locale-Root: "/" in der Standardsprache, "/en/" auf Englisch. Ohne
  // dieses Präfix landet der Kunde nach dem Add im deutschen Warenkorb, und der
  // Rücksprung-Link zeigt auf die deutsche Konfiguratorseite.
  // `window.Shopify.routes.root` endet laut Shopify immer mit einem Slash.
  function shopRoot() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (typeof root !== "string" || root.charAt(0) !== "/") return "/";
    return root.endsWith("/") ? root : root + "/";
  }

  // Pfad in die aktuelle Sprache heben: "/cart" → "/cart" bzw. "/en/cart".
  // Für Seiten UND für die Ajax-Cart-Endpunkte (Shopify empfiehlt, auch die
  // über den Locale-Root zu rufen, damit der Warenkorb im richtigen
  // Sprachkontext antwortet).
  function localizedPath(path) {
    return shopRoot() + String(path).replace(/^\/+/, "");
  }

  // Baut die Combeenation-Edit-URL: <basis-pfad>/<id>/edit/<auth> plus die
  // Query-Parameter der Basis-URL, ergänzt um lang/region. Die Live-Basis kann
  // selbst einen Query tragen (CH: "?currency=CHF") — die Pfadsegmente müssen
  // VOR den Query, sonst entstehen zwei "?" und ein kaputter Link. Deshalb
  // Pfad und Query der Basis trennen, zusammensetzen, dann anhängen.
  function buildEditUrl(baseUrl, id, auth, lang, region) {
    const hashSplit = String(baseUrl).split("#");
    const [pathPart, queryPart] = hashSplit[0].split("?");
    const base = pathPart.replace(/\/+$/, "");
    const path =
      `${base}/${encodeURIComponent(id)}/edit/${encodeURIComponent(auth)}`;
    const params = new URLSearchParams(queryPart || "");
    // lang/region setzen (überschreibt evtl. vorhandene, currency u. a. bleiben).
    params.set("lang", lang);
    params.set("region", region);
    return `${path}?${params.toString()}`;
  }

  // Sprache/Region für den Rücksprung in den Konfigurator. Muster aus Thomas'
  // Preset-Links: `…/<id>/copy?lang=DE&region=DE` — Combeenation erwartet zwei
  // Großbuchstaben. Shopify liefert `locale` als "de" oder "de-CH", davon
  // interessiert nur der Sprachteil; die Region kommt aus `country` (Markt des
  // Besuchers). Beides fehlt außerhalb des Storefronts → Fallback DE.
  function configuratorLocaleParams() {
    const shopify = window.Shopify || {};
    const lang = String(shopify.locale || "").split("-")[0];
    const region = String(shopify.country || "");
    return {
      lang: /^[a-z]{2}$/i.test(lang) ? lang.toUpperCase() : "DE",
      region: /^[a-z]{2}$/i.test(region) ? region.toUpperCase() : "DE",
    };
  }

  // Bundle-Titel in der Sprache des Besuchers. Fester Text je Locale aus CONFIG;
  // ohne Treffer (unbekannte Sprache/leere Map) gilt Combeenations Originaltitel.
  function localizedBundleTitle(originalTitle) {
    const lang = String((window.Shopify && window.Shopify.locale) || "")
      .split("-")[0]
      .toUpperCase();
    const map = CONFIG.BUNDLE_TITLE_BY_LOCALE || {};
    return map[lang] || originalTitle || "Individuelle Konfiguration";
  }

  function showError(message) {
    err(message);
    // Minimaler, unaufdringlicher Hinweis. Theme-spezifisch anpassbar.
    try {
      alert(
        "Die Konfiguration konnte nicht in den Warenkorb gelegt werden.\n\n" +
          message +
          "\n\nBitte versuche es erneut oder kontaktiere uns."
      );
    } catch (_) {}
  }

  // ==========================================================================
  // 3) Storefront API: SKU → variantGid auflösen (Entscheidung E3)
  // --------------------------------------------------------------------------
  // WICHTIG: products(query:) unterstützt in der Storefront API KEIN sku:-
  // Filterfeld (nur title, tag, vendor, …) → SKU-Suche wäre unzuverlässige
  // Freitextsuche. Stattdessen nutzen wir die search-Query, die laut Doku
  // das Feld VARIANTS_SKU durchsucht. Ein einziger GraphQL-Request mit
  // aliasierten Teil-Queries (eine pro SKU). Exakter SKU-Abgleich passiert
  // zusätzlich clientseitig, weil die Suche unscharf matchen kann.
  // ==========================================================================
  async function resolveSkusToGids(skus) {
    const unique = [...new Set(skus)].filter(Boolean);
    if (unique.length === 0) return {};

    // GraphQL-Query dynamisch bauen: r0, r1, … je SKU
    const parts = unique.map((sku, i) => {
      const varName = "$q" + i;
      return `r${i}: search(query: ${varName}, types: [PRODUCT], first: 10, unavailableProducts: SHOW) {
        nodes {
          ... on Product {
            variants(first: 250) { nodes { id sku price { amount } } }
          }
        }
      }`;
    });
    const varDefs = unique.map((_, i) => `$q${i}: String!`).join(", ");
    const query = `query ResolveSkus(${varDefs}) {\n${parts.join("\n")}\n}`;

    const variables = {};
    unique.forEach((sku, i) => {
      variables["q" + i] = sku; // roher SKU-String, search matcht VARIANTS_SKU
    });

    const endpoint = `https://${CONFIG.STOREFRONT_DOMAIN}/api/${CONFIG.STOREFRONT_API_VERSION}/graphql.json`;
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": CONFIG.STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query, variables }),
    });

    if (!res.ok) {
      throw new Error(`Storefront API HTTP ${res.status}`);
    }
    const json = await res.json();
    if (json.errors) {
      throw new Error("Storefront API: " + JSON.stringify(json.errors));
    }

    // Ergebnis auf { SKU: { gid, unitPrice } } reduzieren, exakter Abgleich
    const map = {};
    unique.forEach((sku, i) => {
      const nodes = json.data?.[`r${i}`]?.nodes || [];
      for (const product of nodes) {
        const match = (product.variants?.nodes || []).find(
          (v) => v.sku === sku
        );
        if (match) {
          map[sku] = {
            gid: match.id, // gid://shopify/ProductVariant/…
            unitPrice: Number(match.price?.amount), // echter Shop-Stückpreis
          };
          break;
        }
      }
    });
    return map;
  }

  // ==========================================================================
  // 3b) Konfigurator-Preis centgenau auf die Komponenten verteilen (E1)
  // --------------------------------------------------------------------------
  // Gewichtung: echte Shop-Zeilenwerte (Stückpreis × Menge); Fallback = Menge.
  // Stückpreise werden abgerundet, der Rundungsrest landet auf einer
  // Menge-1-Komponente → Bundle-Summe == Konfigurator-Preis, exakt.
  // Ergebnis: k.price als String "12.34" (Stückpreis) je Komponente.
  // ==========================================================================
  function distributeConfiguratorPrice(stueckliste, totalPrice) {
    const totalCents = Math.round(Number(totalPrice) * 100);
    if (!Number.isFinite(totalCents) || totalCents <= 0 || stueckliste.length === 0) {
      log("Kein gültiger Konfigurator-Preis – Komponenten behalten echte Shop-Preise.");
      return;
    }

    const haveAllPrices = stueckliste.every(
      (k) => Number.isFinite(k._shopUnitPrice) && k._shopUnitPrice > 0
    );
    const weights = stueckliste.map((k) =>
      haveAllPrices ? k._shopUnitPrice * k.quantity : k.quantity
    );
    const weightSum = weights.reduce((a, b) => a + b, 0);

    let assigned = 0;
    stueckliste.forEach((k, i) => {
      const alloc = totalCents * (weights[i] / weightSum);
      k._unitCents = Math.max(0, Math.floor(alloc / k.quantity));
      assigned += k._unitCents * k.quantity;
    });

    // Rundungsrest: exakt auf eine Menge-1-Komponente, sonst kleinste Menge
    const rest = totalCents - assigned;
    if (rest > 0) {
      const carrier =
        stueckliste.find((k) => k.quantity === 1) ||
        stueckliste.reduce((a, b) => (a.quantity <= b.quantity ? a : b));
      if (carrier.quantity === 1) {
        carrier._unitCents += rest;
      } else {
        carrier._unitCents += Math.round(rest / carrier.quantity);
        log(`Rundungsrest ${rest} Cent ohne Menge-1-Komponente – minimale Abweichung möglich.`);
      }
    }

    stueckliste.forEach((k) => {
      k.price = (k._unitCents / 100).toFixed(2);
      delete k._unitCents;
    });
    log(`Preisverteilung: ${totalCents / 100} auf ${stueckliste.length} Komponenten verteilt.`);
  }

  // ==========================================================================
  // 4) bom → _Stückliste-Array bauen (mit variantGid)
  // ==========================================================================
  async function buildStueckliste(bom, configuratorPrice) {
    // SKUs sammeln, die noch aufgelöst werden müssen
    const needsResolve = bom.filter((c) => !c.variantGid);
    const skusToResolve = needsResolve.map((c) => c[CONFIG.BOM_SKU_FIELD]);

    let skuMap = {};
    if (skusToResolve.length > 0) {
      skuMap = await resolveSkusToGids(skusToResolve);
    }

    const stueckliste = [];
    const missing = [];

    for (const c of bom) {
      const sku = c[CONFIG.BOM_SKU_FIELD];
      const qty = Number(c[CONFIG.BOM_QTY_FIELD]);
      const resolved = skuMap[sku];
      // Falls Combeenation die GID doch mitliefert: bevorzugt nutzen
      const variantGid = c.variantGid || (resolved && resolved.gid);

      if (!variantGid || !qty || qty <= 0) {
        missing.push(sku || "(ohne SKU)");
        continue;
      }
      stueckliste.push({
        variantGid,
        sku,
        quantity: qty,
        // interner Helfer für die Preisverteilung, wird unten entfernt
        _shopUnitPrice: resolved && Number.isFinite(resolved.unitPrice) ? resolved.unitPrice : null,
      });
    }

    // E1: Konfigurator-Preis erzwingen → k.price je Komponente setzen
    // (nur wenn aktiviert; ohne price-Felder nutzt die Function echte Shop-Preise)
    if (CONFIG.ENFORCE_CONFIGURATOR_PRICE) {
      distributeConfiguratorPrice(stueckliste, configuratorPrice);
    }
    for (const k of stueckliste) delete k._shopUnitPrice;

    return { stueckliste, missing };
  }

  // ==========================================================================
  // 5) Anzeige-Properties für die Warenkorb-Position aufbereiten
  // ==========================================================================
  function buildDisplayProperties(configuration, data) {
    const props = {};

    // Menschenlesbare Detail-Infos (details-Array). Sichtbar im Warenkorb.
    if (Array.isArray(configuration.details)) {
      for (const d of configuration.details) {
        if (d && d.name) props[d.name] = String(d.value ?? "");
      }
    }

    // Interne Properties (führender Unterstrich = im Theme meist versteckt)
    props._bundleTitle = localizedBundleTitle(configuration.title);
    if (configuration.imageUrl && CONFIG.SEND_BUNDLE_IMAGE) {
      props._bundleImage = configuration.imageUrl;
    }

    // Konfigurator-Rendering für die ANZEIGE im Warenkorb. Bewusst getrennt von
    // _bundleImage: das geht durch die Function in `image.url` und wurde von
    // Shopify mit InvalidOutputErr → 422 beim Add abgelehnt (deshalb steht
    // SEND_BUNDLE_IMAGE auf false). _configImage fasst die Function nicht an,
    // das Theme liest es direkt aus item.properties. Kein 422-Risiko.
    if (configuration.imageUrl) {
      props._configImage = String(configuration.imageUrl);
    }

    // Konfigurations-Referenzen für Support / Rückverfolgung / Rücksprung.
    // ⚠️ Der echte Combeenation-Konfigurator liefert die Konfigurations-ID unter
    // data.id und das Auth-Token unter data.authentication (NICHT configurationId/
    // configurationAuth — das war eine falsche Annahme aus der abgespeckten Demo).
    // Fallback auf die alten Namen, falls eine andere Version sie doch so liefert.
    const configId = data.id ?? data.configurationId;
    const configAuth = data.authentication ?? data.configurationAuth;
    if (configId != null && configId !== "") {
      props._configurationId = String(configId);
      // Edit-Rücksprung: bestehende Konfiguration weiterbearbeiten. Braucht id
      // UND Auth-Token. Die Function schreibt diese URL auf die Kopfzeile, das
      // Theme rendert daraus im Warenkorb einen "Bearbeiten"-Link.
      if (configAuth != null && configAuth !== "" && CONFIG.CONFIGURATOR_BASE_URL) {
        // lang/region gehören an die INNERE Combeenation-URL, nicht an die
        // Shop-Seite — sonst öffnet der Konfigurator wieder auf Deutsch.
        const { lang, region } = configuratorLocaleParams();
        const editUrl = buildEditUrl(
          CONFIG.CONFIGURATOR_BASE_URL,
          String(configId),
          String(configAuth),
          lang,
          region
        );
        // Combeenation-Vorgabe: die Edit-URL NICHT direkt verlinken, sondern
        // URL-encodiert über ?combeenationurl=… an die Shop-Konfiguratorseite
        // hängen → Konfigurator öffnet im Shop, Re-Add in den Warenkorb möglich.
        // Die Konfiguratorseite in der Sprache öffnen, in der der Kunde gerade
        // unterwegs ist. Der Link steckt als Property in der Cart-Line, er
        // behält also die Sprache des Moments, in dem konfiguriert wurde.
        props._configEditUrl =
          `${localizedPath(CONFIG.CONFIGURATOR_PAGE_URL)}?combeenationurl=` +
          encodeURIComponent(editUrl);
      }
    }

    // E4: signierte Checkout-Daten durchreichen. WICHTIG: checkoutParameters
    // ist der ROH-String von Combeenation — der HMAC gilt über exakt diese
    // Bytes. Niemals parsen + re-serialisieren!
    if (typeof data.checkoutParameters === "string") {
      props._checkoutParameters = data.checkoutParameters;
    }
    if (data.checkoutParametersHash) {
      props._checkoutParametersHash = String(data.checkoutParametersHash);
    }

    return props;
  }

  // ==========================================================================
  // 5b) Trennposition je Konfigurator in den Warenkorb legen (Weg A)
  // --------------------------------------------------------------------------
  // Wird VOR der Parent-Position aufgerufen, damit die Trenner-Zeile im Cart
  // direkt vor "ihrer" Konfiguration steht (/cart/add.js hängt Zeilen in
  // Add-Reihenfolge an). Eindeutigkeit kommt aus instanceKey (NICHT aus der
  // evtl. fehlenden configurationId) → zwei Trenner verschmelzen nie. Kein
  // _Stückliste → die Function lässt ihn unangetastet.
  // ==========================================================================
  async function addSeparator(configuration, data, instanceKey) {
    if (!CONFIG.ADD_SEPARATOR) return;
    if (!CONFIG.SEPARATOR_VARIANT_ID) {
      log(
        "ADD_SEPARATOR aktiv, aber SEPARATOR_VARIANT_ID nicht gesetzt – " +
          "Trennposition übersprungen (Bundle-Setup-Button ausführen)."
      );
      return;
    }

    const title = configuration.title || "Individuelle Konfiguration";
    const nr = (await countExistingSeparators()) + 1; // laufende Nummer im Cart

    const props = {};
    // Sichtbar im Warenkorb: laufende Nummer + Titel der folgenden Konfiguration
    props["Konfiguration"] = `${nr} – ${title}`;
    // Eindeutiger Diskriminator → verhindert das Zusammenfassen (Mengen-
    // Hochzählen) mehrerer Trenner, komplett unabhängig von der configurationId.
    props._configuratorInstance = instanceKey;
    // configurationId zusätzlich mitgeben, falls Combeenation sie liefert
    // (Rückverfolgung für plentymarkets). Fehlt sie, ist das dank instanceKey
    // kein Problem mehr für die Trennung.
    if (data.configurationId) {
      props._configurationId = String(data.configurationId);
    } else {
      log(
        "Trennposition ohne configurationId – Trennung erfolgt über instanceKey " +
          "(configurationId nur zur Rückverfolgung, fehlt hier)."
      );
    }

    const res = await fetch(localizedPath("/cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: CONFIG.SEPARATOR_VARIANT_ID,
        quantity: 1,
        properties: props,
      }),
    });
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`/cart/add.js (Trenner) HTTP ${res.status} ${text}`);
    }
    return res.json();
  }

  // ==========================================================================
  // 6) In den Warenkorb legen (Ajax API)
  // ==========================================================================
  async function addToCart(stueckliste, displayProps) {
    if (!CONFIG.PARENT_VARIANT_ID) {
      throw new Error("CONFIG.PARENT_VARIANT_ID ist nicht gesetzt.");
    }

    const body = {
      id: CONFIG.PARENT_VARIANT_ID,
      quantity: 1,
      properties: Object.assign({}, displayProps, {
        // Die eigentliche Stückliste – hierauf greift die Cart Transform Function zu
        // ⚠️ Key MUSS zu src/cart_transform_run.graphql passen. Bewusst NICHT
        // "_Stückliste": den schreibt die alte, noch live laufende Bridge-Version
        // ohne Signatur — die Function würde solche Zeilen fail-closed ablehnen
        // und über blockOnFailure den laufenden Betrieb blockieren.
        _konektraBundleV2: JSON.stringify(stueckliste),
      }),
    };

    const res = await fetch(localizedPath("/cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`/cart/add.js HTTP ${res.status} ${text}`);
    }
    return res.json();
  }

  // ==========================================================================
  // 7) Haupt-Callback des Konfigurators
  // ==========================================================================
  // Robuste Ermittlung des configuration-Objekts (flexCheckoutJSON).
  // Offizielle Demo: data.checkoutParameters ist ein JSON-STRING → JSON.parse.
  // Fallbacks: bereits geparstes Objekt, oder data selbst enthält schon bom.
  function extractConfiguration(data) {
    const cp = data && data.checkoutParameters;
    if (typeof cp === "string") return JSON.parse(cp);
    if (cp && typeof cp === "object") return cp; // schon geparst
    if (data && Array.isArray(data.bom)) return data; // data == configuration
    throw new Error("Konnte checkoutParameters/configuration nicht ermitteln.");
  }

  // Handler einer anderen Integration auf derselben Seite (Combeenation-App mit
  // den vorgefertigten Konfigurationen). Wird bei der Registrierung unten
  // eingesammelt und für alles aufgerufen, was nicht unser Format ist.
  let legacyHandler = null;

  // Ist das unser Payload? Nur der Flex-Checkout liefert checkoutParameters als
  // JSON-String. Die vorgefertigten Konfigurationen liefern stattdessen
  // `main.customFields` (mit `_Stückliste` als {productNumber, productName,
  // quantity}) — anderes Format, andere Artikelnummern, keine Signatur. Solche
  // Payloads gehören nicht uns.
  function isFlexCheckoutPayload(data) {
    return typeof data?.checkoutParameters === "string" && data.checkoutParameters.length > 0;
  }

  const onCheckout = async function (data) {
    log("Rohdaten vom Konfigurator:", data);

    // Fremder Payload → an die vorhandene Integration zurückgeben, damit
    // vorgefertigte Konfigurationen weiter in den Warenkorb gelegt werden können.
    if (!isFlexCheckoutPayload(data)) {
      if (legacyHandler) {
        log("Kein checkoutParameters – Payload an die vorhandene Integration weitergegeben.");
        return legacyHandler(data);
      }
      showError(
        "Diese Konfiguration liefert keine signierten Checkout-Daten " +
          "(checkoutParameters fehlt) und es ist keine andere Integration aktiv, " +
          "die sie verarbeiten könnte."
      );
      return;
    }

    try {
      // E4: ohne GÜLTIGE Signatur gar nicht erst in den Cart legen — die Function
      // würde die Position ohnehin nicht expandieren (fail-closed).
      if (CONFIG.REQUIRE_HMAC && !data?.checkoutParametersHash) {
        throw new Error(
          "Checkout-Daten sind nicht signiert (checkoutParametersHash fehlt). " +
            "Bitte Combeenation-Konfigurator-Version prüfen."
        );
      }

      const configuration = extractConfiguration(data);
      log("Geparste Konfiguration (flexCheckoutJSON):", configuration);

      // Vorgefertigte Konfigurationen liefern ein ANDERES Schema im selben
      // (signierten) checkoutParameters: `products[0].main.customFields` mit
      // `_Stückliste` als [{productNumber, productName, quantity}]. Die
      // productNumber ist Combeenations interne variationId (z. B. "3172") und im
      // Shopify-Katalog nicht auffindbar — geprüft am 04.08.2026 über die
      // Storefront-Suche. Ohne Shopify-SKU ist keine Auflösung möglich, deshalb
      // hier eine klare Meldung statt "bom leer".
      if (!Array.isArray(configuration.bom) && Array.isArray(configuration.products)) {
        throw new Error(
          "Diese Konfiguration nutzt das alte Combeenation-Schema " +
            "(products[].main.customFields) und liefert interne Artikelnummern " +
            "statt Shopify-SKUs. Sie kann nicht in Einzelteile aufgelöst werden. " +
            "Combeenation muss für vorgefertigte Konfigurationen denselben " +
            "bom-Aufbau liefern wie für den Flex-Checkout."
        );
      }

      const bom = Array.isArray(configuration.bom) ? configuration.bom : [];
      if (bom.length === 0) {
        throw new Error("Konfiguration enthält keine Stückliste (bom leer).");
      }

      // SKU → variantGid auflösen, _Stückliste bauen, Konfigurator-Preis verteilen
      const { stueckliste, missing } = await buildStueckliste(bom, configuration.price);

      // Fail-safe: keine Position mit fehlenden Komponenten in den Cart legen
      if (missing.length > 0 || stueckliste.length === 0) {
        throw new Error(
          "Für folgende SKUs wurde keine Shopify-Variante gefunden: " +
            missing.join(", ")
        );
      }

      // Eindeutiger Schlüssel für DIESE Konfigurator-Instanz, der auf die
      // Parent-Position gelegt wird. WICHTIG auch bei Weg B: verhindert, dass
      // zwei IDENTISCHE Konfigurationen im Ajax-Cart zu einer Zeile (Menge 2)
      // verschmelzen, BEVOR die Function läuft — sonst gäbe es nur eine
      // Kopfzeile für beide. So bleibt jede Konfiguration eine eigene Gruppe.
      const instanceKey = uniqueInstanceKey();

      const displayProps = buildDisplayProperties(configuration, data);
      displayProps._configuratorInstance = instanceKey;

      log("_Stückliste:", stueckliste);
      log("Anzeige-Properties:", displayProps);

      // Trennposition zuerst, damit sie im Cart vor der Parent-Position steht.
      // Sie ist rein kosmetisch/organisatorisch → ihr Fehlschlag darf den Kauf
      // NICHT blockieren. Der eigentliche Add (Parent) folgt in jedem Fall.
      try {
        await addSeparator(configuration, data, instanceKey);
      } catch (sepErr) {
        err(
          "Trennposition konnte nicht gelegt werden (Bestellung läuft trotzdem weiter): " +
            (sepErr && sepErr.message ? sepErr.message : String(sepErr))
        );
      }

      await addToCart(stueckliste, displayProps);

      const cartUrl = localizedPath(CONFIG.CART_REDIRECT_URL);
      log("Erfolgreich in den Warenkorb gelegt → Weiterleitung nach " + cartUrl);
      window.location.href = cartUrl;
    } catch (e) {
      showError(e.message || String(e));
    }
  };

  // ==========================================================================
  // 8) Callback-Registrierung — bewusst am VORDERSTEN Namen
  // ==========================================================================
  // Das Combeenation-Plugin ruft NUR DEN ERSTEN vorhandenen Handler dieser
  // Kette auf (belegt im Plugin-Quelltext, _callOnConfigurationFinished):
  //   window.CombeenationSaveToCart
  //   → Combeenation.SaveToCart
  //   → Combeenation.OnCheckout
  //   → Combeenation.onCheckout
  //   → Combeenation.onConfigurationFinished
  //
  // Solange die alte Combeenation-App parallel läuft (sie wird erst mit dem
  // Go-Live abgeschaltet), kann sie einen der vorderen Namen belegen. Hingen wir
  // nur an `onCheckout`, würde unsere Bridge dann NIE aufgerufen — stiller
  // Ausfall ohne Fehlermeldung, auch in Theme-Vorschauen (App-Embeds laufen dort
  // mit). Deshalb belegen wir den vordersten Namen und schützen ihn gegen
  // spätere Überschreibung; die hinteren Namen zeigen auf denselben Handler.
  // ⚠️ WICHTIG: Wir übernehmen den Callback, geben ihn aber für FREMDE Payloads
  // wieder ab. Auf denselben Seiten läuft die Combeenation-App mit den
  // vorgefertigten Konfigurationen, und die liefert eine völlig andere Struktur
  // (`main.customFields` mit `_Stückliste` als {productNumber, productName,
  // quantity}) — ohne checkoutParameters und ohne Hash. Würden wir die abweisen,
  // ließen sich vorgefertigte Produkte nicht mehr in den Warenkorb legen.
  // Deshalb merken wir uns den zuvor registrierten Handler und rufen ihn für
  // alles auf, was nicht unser signiertes Format ist (s. `delegateLegacy`).
  const FOREIGN = [];
  const rememberLegacy = (fn, label) => {
    if (typeof fn !== "function" || fn === onCheckout) return;
    FOREIGN.push(label);
    if (!legacyHandler) legacyHandler = fn; // erster Treffer = Reihenfolge des Plugins
  };
  rememberLegacy(window.CombeenationSaveToCart, "CombeenationSaveToCart");
  if (window.Combeenation) {
    for (const n of ["SaveToCart", "OnCheckout", "onCheckout", "onConfigurationFinished"]) {
      rememberLegacy(window.Combeenation[n], "Combeenation." + n);
    }
  }
  if (FOREIGN.length) {
    log(
      "Fremde Checkout-Handler gefunden (" +
        FOREIGN.join(", ") +
        ") – vermutlich die Combeenation-App. Signierte Konfigurationen übernimmt " +
        "diese Bridge, alles andere wird an den vorhandenen Handler weitergegeben."
    );
  }

  try {
    Object.defineProperty(window, "CombeenationSaveToCart", {
      get: () => onCheckout,
      // Wer uns später überschreiben will, wird stattdessen unser Delegat:
      // so gewinnen wir unabhängig von der Ladereihenfolge, ohne die andere
      // Integration lahmzulegen.
      set: (fn) => {
        if (typeof fn === "function" && fn !== onCheckout) {
          legacyHandler = fn;
          log("Späterer Handler registriert – wird für fremde Payloads genutzt.");
        }
      },
      configurable: false,
    });
  } catch (e) {
    // Ein anderes Skript hat den Namen schon nicht-konfigurierbar belegt.
    // Dann bleibt nur die einfache Zuweisung; greift, solange wir später laden.
    err("CombeenationSaveToCart ließ sich nicht schützen: " + (e && e.message));
    try {
      window.CombeenationSaveToCart = onCheckout;
    } catch (e2) {
      err("CombeenationSaveToCart ist blockiert – Bridge wird NICHT aufgerufen! " + (e2 && e2.message));
    }
  }

  // Zusätzlich die hinteren Namen belegen (Fallback für Konfigurator-Versionen,
  // die eine andere Reihenfolge nutzen).
  window.Combeenation = window.Combeenation || {};
  window.Combeenation.SaveToCart = onCheckout;
  window.Combeenation.OnCheckout = onCheckout;
  window.Combeenation.onCheckout = onCheckout;
  window.Combeenation.onConfigurationFinished = onCheckout;

  log("Bridge-JS geladen. Warte auf Checkout-Callback …");
})();
